import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Header from "../Pages/JS/Header";
import Footer from "../Pages/JS/Footer";
import ScrollToTop from "../Pages/JS/ScrollToTop";

// Lazy loading pages
const Homepage = lazy(() => import("../Pages/JS/Homepage"));
const About = lazy(() => import("../Pages/JS/About"));
const Services = lazy(() => import("../Pages/JS/Services"));

// Define animation variants for page transitions
const pageVariants = {
 initial: {
  opacity: 0,
  x: "-100vw", // Slide in from the left
  y: "100vw",
 },
 in: {
  opacity: 1,
  x: 0,
  y: 0, // In place
 },
 out: {
  opacity: 0,
  x: "100vw",
  y: "-100vw", // Slide out to the right
 },
};

const pageTransition = {
 duration: 0.4, // Animation duration
};

const AnimatedRoutes = () => {
 const location = useLocation(); // For tracking route changes

 return (
  <AnimatePresence mode="wait">
   {" "}
   {/* Enables wait mode for smoother transitions */}
   <Routes location={location} key={location.pathname}>
    <Route
     path="/"
     element={
      <motion.div
       initial="initial"
       animate="in"
       exit="out"
       variants={pageVariants}
       transition={pageTransition}
      >
       <Homepage />
      </motion.div>
     }
    />
    <Route
     path="/about"
     element={
      <motion.div
       initial="initial"
       animate="in"
       exit="out"
       variants={pageVariants}
       transition={pageTransition}
      >
       <About />
      </motion.div>
     }
    />
    <Route
     path="/services"
     element={
      <motion.div
       initial="initial"
       animate="in"
       exit="out"
       variants={pageVariants}
       transition={pageTransition}
      >
       <Services />
      </motion.div>
     }
    />
   </Routes>
  </AnimatePresence>
 );
};

const RouterPath = () => {
 return (
  <Router>
   <ScrollToTop />
   <Header />
   <Suspense fallback={<div>Loading...</div>}>
    <AnimatedRoutes />
   </Suspense>
   {/* <Footer /> */}
  </Router>
 );
};

export default RouterPath;
